(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('resourceStrings', function(resourceService) {
    return {
        restrict: 'A',
        link(scope, el, attr) {
            if (attr.resourceStrings != null) {
                resourceService.set(JSON.parse(attr.resourceStrings));
            }
        }
    };
});
})();
